<template>
  <div class="summary">
    <div class="summary__namegroup">
      <p class="summary__name renalutFont">{{ summaryList.name }}</p>
      <p class="summary__gradename renalutFont">{{ summaryList.grade_name }}</p>
      <p class="summary__jpname">{{ summaryList.jp_name }}</p>
    </div>

    <p class="summary__price">
    <span>¥ {{ summaryList.total_price }}</span>（税込）
    </p>
    <p class="note">※金額は全て税込表記となります</p>
    <img
      :src="summaryList.image"
      alt=""
      v-if="isVisibleCarImage"
      class="summary__carimg"
    />

    <div class="btn_container sp_only">
      <button class="btn summary_btn" @click="gotoSimulation()">
        シミュレーション結果
      </button>
    </div>
    <p
      class="panel_ui summary_close"
      v-if="isVisible"
      @click="isVisible = !isVisible"
    >
      <img src="@/assets/img/icon_catre_down.png" alt="" />
    </p>

    <div v-if="!isVisible">
      <p class="panel_ui" @click="isVisible = !isVisible">
        <img src="@/assets/img/icon_catre_up.png" alt="" />
      </p>

      <section class="summary__group">
        <p class="summary__grouptitle">カラー</p>

        <div class="summary__detail">
          <p class="summary__subtitle">エクステリア</p>
          <p class="summary__value">
            <span>¥ {{ summaryList.color_price }}</span>
          </p>
        </div>
        <p class="summary__name">{{ summaryList.name_exterior }}</p>

        <div class="summary__detail">
          <p class="summary__subtitle">インテリア</p>
          <p class="summary__value">
            <span>¥ {{ summaryList.price_interior }}</span>
          </p>
        </div>
        <p class="summary__name">{{ summaryList.name_interior }}</p>
      </section>

      <section class="summary__group">
        <p class="summary__grouptitle">オプション</p>

        <div v-for="itemGroup in summaryList.makeroptions" :key="itemGroup.name">
          <template class="" v-for="item in itemGroup.list" :key="item.name">
<!--        <p class="summary__subtitle">{{ itemGroup.name }}</p> -->
            <div class="summary__detail">
              <p class="summary__name">{{ item.name }}</p>
              <p class="summary__value">
                <span>¥ {{ item.price }}</span>
              </p>
            </div>
          </template>
        </div>

        <div v-for="itemGroup in summaryList.accessories" :key="itemGroup.name">
          <template class="" v-for="item in itemGroup.list" :key="item.name">
<!--        <p class="summary__subtitle">{{ itemGroup.name }}</p> -->
            <div class="summary__detail">
              <p class="summary__name">{{ item.name }}</p>
              <p class="summary__value">
                <span>¥ {{ item.price }}</span>
              </p>
            </div>
          </template>
        </div>

        <div v-for="itemGroup in summaryList.services" :key="itemGroup.name">
          <template class="" v-for="item in itemGroup.list" :key="item.name">
<!--        <p class="summary__subtitle">{{ itemGroup.name }}</p> -->
            <div class="summary__detail">
              <p class="summary__name">{{ item.name }}</p>
              <p class="summary__value">
                <span>¥ {{ item.price }}</span>
              </p>
            </div>
          </template>
        </div>
        <p class="summary__name" v-if="select_item_number === 0">選択されていません</p>
      </section>
    </div>
  </div>
  <div class="btn_container pc_only">
    <button class="btn summary_btn" @click="gotoSimulation()">
      シミュレーション結果
    </button>
  </div>
</template>

<script>
import {
  props,
  context,
  inject,
  reactive,
  ref,
  toRefs,
  watch,
  onMounted,
} from "vue";
import RjConfiguration from "../functions/RjConfiguration";

export default {
  props: ["isVisibleCarImage", "isChange"],
  setup(props, context) {
    const RJ = RjConfiguration();
    const select_car = RJ.getDataCar();
    const select_grade = RJ.getDataGreade();
    let select_color = RJ.getDataColor();
    let select_makeroptions = RJ.getDataMakerOptions();
    let select_accessories = RJ.getDataAccessories();
    let select_services = RJ.getDataServices();
    let total_price = RJ.getTotalPrice();
    let summaryList = reactive({
      name: select_car.name,
      grade_name: select_grade.name,
      jp_name: select_grade.name_jp,
      price: select_grade.price,
      image: select_color.image,
      name_exterior: select_color.name,
      name_interior: select_color.name_interior,
      price_interior: 0, //将来使用するため
      color_price: select_color.price,
      makeroptions: select_makeroptions,
      accessories: select_accessories,
      services: select_services,
      total_price: total_price,
    });
    let select_item_number = ref(null);
    let isVisible = ref(false);

    //選択しないを表示する実装
    onMounted(() => {
      select_item_number.value = 0;
      for (let i = 0; i < summaryList.makeroptions.length; i++) {
        select_item_number.value =
          select_item_number.value + summaryList.makeroptions[i].list.length;
      }
      for (let i = 0; i < summaryList.accessories.length; i++) {
        select_item_number.value =
          select_item_number.value + summaryList.accessories[i].list.length;
      }

      for (let i = 0; i < summaryList.services.length; i++) {
        select_item_number.value =
          select_item_number.value + summaryList.services[i].list.length;
      }
    });
    // シミュレーション結果
    const gotoSimulation = () => {
      const indexSimulation = RJ.getMenuList().length - 1; //最後のメニューがシミュレーションなので
      RJ.gotoMenu(indexSimulation);
    };
    const watchChange = watch(props.isChange, (newValues) => {
      select_color = RJ.getDataColor();
      select_makeroptions = RJ.getDataMakerOptions();
      select_accessories = RJ.getDataAccessories();
      select_services = RJ.getDataServices();
      total_price = RJ.getTotalPrice();
      summaryList.image = select_color.image;
      summaryList.name_exterior = select_color.name;
      summaryList.name_interior = select_color.name_interior;
      summaryList.color_price = select_color.price;
      summaryList.makeroptions = select_makeroptions;
      summaryList.accessories = select_accessories;
      summaryList.services = select_services;
      summaryList.total_price = total_price;
      //選択しないを表示する実装
      select_item_number.value = 0;
      for (let i = 0; i < summaryList.makeroptions.length; i++) {
        select_item_number.value =
          select_item_number.value + summaryList.makeroptions[i].list.length;
      }
      for (let i = 0; i < summaryList.accessories.length; i++) {
        select_item_number.value =
          select_item_number.value + summaryList.accessories[i].list.length;
      }

      for (let i = 0; i < summaryList.services.length; i++) {
        select_item_number.value =
          select_item_number.value + summaryList.services[i].list.length;
      }
    });

    return {
      isVisible,
      summaryList,
      gotoSimulation,
      watchChange,
      select_item_number,
    };
  },
};
</script>
<style scoped></style>
